export default __webpack_public_path__ + "static/media/yokara-logo-footer.a48ba570.png";